import { ReactNode } from 'react';

import { clsx } from '@freelancelabs/utils';

export interface CardProps {
    children: ReactNode;
    /** Rendered as the card heading. Omit it for a card that carries no title. */
    title?: string;
    /** Actions aligned opposite the title: an edit button, a link. */
    actions?: ReactNode;
    className?: string;
}

/**
 * Section card of the portal. Inside a `Fiche` it takes the detail look: warm grey
 * border and wider radius: without anything to declare here: the sheet is the one
 * that carries the context.
 */
const Card = ({ children, title, actions, className }: CardProps) => (
    <section className={clsx('fl-card', className)}>
        {(title || actions) && (
            <div className="fl-card__head">
                {title && <h2 className="fl-card__title">{title}</h2>}
                {actions}
            </div>
        )}
        {children}
    </section>
);

export default Card;
